import { useMutation } from '@tanstack/react-query';
import {
  MerchantApiCredentialsService,
  UpdateMerchantCredentialStatusDto,
} from 'services/openapi';

type UpdateMerchantCredentialStatusMutationVariables =
  UpdateMerchantCredentialStatusDto & {
    id: string;
  };

export const useUpdateMerchantCredentialStatusMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<any, Error, UpdateMerchantCredentialStatusMutationVariables>({
      mutationFn: ({ id, ...requestBody }) =>
        MerchantApiCredentialsService.merchantApiControllerUpdateClientStatus(
          id,
          requestBody,
        ),
    });

  return { isLoading, isSuccess, error, data, isError, mutate, mutateAsync };
};
